'use client'

import { useEnrichedFilters } from '@/feature/product/hooks/useEnrichedFilters'
import { MAX_SELECTABLES_COLUMNS } from '@/feature/product/hooks/useReferencesProduct'
import {
  referencesProductFiltersEnrichedAtom,
  referencesProductSelectableColumnsAtom,
  referencesProductSelectedColumnsAtom,
} from '@/feature/product/services/referencesProduct.store'
import { gql } from '@gql-generated/gql'
import type { ReferencesProductFilters_FiltersFragment } from '@gql-generated/graphql'
import { useAtom, useAtomValue } from 'jotai'
import { useCallback, useEffect } from 'react'
import { ReferencesProductFiltersDesktop } from './ReferencesProductFiltersDesktop.client'
import { ReferencesProductFiltersMobile } from './ReferencesProductFiltersMobile.client'

gql(/* GraphQL */ `
  fragment ReferencesProductFilters_Filters on ProductFilter {
    label
    values {
      label
      references
    }
    unit
  }
`)

export type ReferencesProductFiltersProps = {
  filters: ReferencesProductFilters_FiltersFragment[]
}

export function ReferencesProductFilters({ filters: filtersProps }: ReferencesProductFiltersProps) {
  const referencesProductFiltersEnriched = useAtomValue(referencesProductFiltersEnrichedAtom)
  const [selectableColumns, setSelectableColumns] = useAtom(referencesProductSelectableColumnsAtom)
  const [selectedColumns, setSelectedColumns] = useAtom(referencesProductSelectedColumnsAtom)
  useEnrichedFilters(filtersProps)

  const handleInitialColumns = useCallback(() => {
    if (!selectableColumns.length && !selectedColumns.length) {
      const filtersLabels = referencesProductFiltersEnriched.map((filter) => filter.label)
      const initialColumns = filtersLabels.slice(0, MAX_SELECTABLES_COLUMNS)

      setSelectableColumns(filtersLabels)
      setSelectedColumns(initialColumns)
    }
  }, [
    referencesProductFiltersEnriched,
    selectableColumns,
    selectedColumns,
    setSelectableColumns,
    setSelectedColumns,
  ])

  useEffect(() => {
    handleInitialColumns()
  }, [handleInitialColumns])

  return (
    <div className="z-popover sticky-mobile-to-header">
      <ReferencesProductFiltersMobile />
      <ReferencesProductFiltersDesktop />
    </div>
  )
}
